module.exports = __webpack_public_path__ + "img/illustrations-sold-out.0615c302.svg";